import { LoyolaServices } from '.';

export default class AdminConfig {

  static getDataConfig(user) {
    return LoyolaServices.getDataConfig().then(res => {
      sessionStorage.setItem('adminConfig', JSON.stringify(res.data.data))
    })
  }
}